// @flow
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import configureStore from '../../redux/store';

import App from '../App/App';

const store = configureStore();

class Root extends Component {
    componentDidMount() {
        // store.dispatch(loadSharedData());
    }

    render() {
        return (
            <Router>
                <Provider store={store}>
                    <App />
                </Provider>
            </Router>
        );
    }
}

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root/Root.js